/** TravelVault pricing catalog. Amounts are display-only — Stripe is the source of truth. */

export const FEATURES = {
  free: [
    "1 trip",
    "Unlimited travelers per trip",
    "Basic flight, hotel, car storage",
    "Receipt photos & summary",
  ],
  pro: [
    "Unlimited trips",
    "Assign travelers to reservations",
    "Passport & medical vault",
    "Priority storage upload",
    "Cancel anytime",
  ],
  family: [
    "Everything in Pro",
    "Designed for up to 6 travelers",
    "Shared vault for family docs",
    "Kid-specific & guardian info",
    "Emergency contact quick-share",
  ],
};

export const PLANS = {
  pro: {
    name: "Pro",
    tagline: "For solo travelers who plan a lot.",
    monthlyPrice: 7.99,
    annualPrice: 79.90,
    monthlyLookup: "pro_monthly",
    annualLookup: "pro_annual",
    features: FEATURES.pro,
    highlight: true,
  },
  family: {
    name: "Family",
    tagline: "For families and small groups on the go.",
    monthlyPrice: 14.99,
    annualPrice: 149.90,
    monthlyLookup: "family_monthly",
    annualLookup: "family_annual",
    features: FEATURES.family,
    highlight: false,
  },
};

export function formatMoney(cents, currency = "usd") {
  const sign = cents < 0 ? "-" : "";
  const abs = Math.abs(cents) / 100;
  try {
    return sign + new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: (currency || "usd").toUpperCase(),
    }).format(abs);
  } catch {
    return `${sign}$${abs.toFixed(2)}`;
  }
}

export function money(n) {
  return `$${Number(n).toFixed(2)}`;
}
